import './App.css';
import { SignUpLogIn } from './Components/SignUpLogIn';

function App() {
  return (
    <div className="container">
      <SignUpLogIn  />
    </div>
  );
}

export default App;
